import {ResponsiveContent} from "./ResponsiveNavTabs";
import React from "react";
import {Formik, Form as FormikForm} from "formik";
import {ColumnizeText, PageTitle, CustomRecaptcha, SingleText} from "./_components";
import * as yup from "yup";
import {Button, Container, Stack} from "react-bootstrap";
import {useAlert, useAuth, useDarkMode} from "../context";
import {fetchWrapper} from "../_services/fetch";
import {config} from "../utils2";

export function ContactUs() {
    return <ResponsiveContent body={<ContactBody/>}/>
}

function ContactBody() {
    const {loggedIn, user} = useAuth()
    const {success, error} = useAlert()

    const validationSchema = yup.object().shape({
        name: yup.string().required("Name cannot be empty"),
        email: yup.string().required("Email cannot be empty"),
        subject: yup.string().required("Subject cannot be empty"),
        message: yup.string().required("Message cannot be empty"),
        recaptcha: yup.string().required("Please complete the reCAPTCHA verification")
    })

    const initialValues = {
        name: loggedIn ? user?.first_name : "",
        email: loggedIn ? user?.username : "",
        subject: "",
        message: "",
        recaptcha: "",
    }


    function handleSubmit(values, actions) {
        const msg = "Fetch failed with no error messages from the server."
        const endpoint = config.get_remote_api() + "/api/contact/send-email"

        fetchWrapper.post(endpoint, values)
            .then(resp => {
                if (resp?.success) {
                    success("Message sent!")
                    actions.resetForm()
                } else {
                    error(resp?.message || msg)
                }
            })
            .catch(err => error(err?.error || err?.message || msg))
            .finally(() => actions.setSubmitting(false))

    }

    return <Container fluid="lg">
        <PageTitle title="Contact Us">We're here to help! Don't hesitate to contact us with any questions about our products, your order, or anything else. Our team will
            respond
            shortly.</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm, setFieldValue, errors, touched}) => (
                <FormikForm>

                    <ColumnizeText className="mt-4">
                        <SingleText name="name" label="Name"/>
                        <SingleText name="email" label="Email"/>
                    </ColumnizeText>

                    <SingleText name="subject" label="Subject" className="mt-4" tip="Issue with Orders #12345/Question About Product XYZ"/>

                    <SingleText name="message" type="textarea" label="Message" className="my-2"/>


                    <div className="py-2 d-flex justify-content-end align-items-end flex-column">
                        <CustomRecaptcha onChange={value => setFieldValue("recaptcha", value)}/>
                        <div>
                            {errors.recaptcha && touched.recaptcha && (
                                <div className="text-danger">{errors.recaptcha}</div>
                            )}
                        </div>
                    </div>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>Send</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>
    </Container>
}